export default __webpack_public_path__ + "static/media/waving_hand.760098cf.png";